import Vue from 'vue';

Vue.component('vuetable-price-override', () =>
    import(/* webpackChunkName: 'price-override-index' */ './vuetable-price-override.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/report/price-override/index.js